<div class="wrapper mat-elevation-z8">
  <table>
    <thead #thead>
      <tr class="group-row">
        <th
          *ngFor="let group of dataDefinition; index as g"
          [attr.colspan]="group.columns.length"
          [class]="g > 0 ? 'divider-column' : ''"
        >
          {{ group.hideGroupName === true ? "" : group.name }}
        </th>
        <th
          colspan="1"
          class="divider-column buttons-column"
          *ngIf="buttonsColumnVisible"
        >
        </th>
      </tr>
      <tr>
        <ng-container *ngFor="let group of dataDefinition; index as g">
          <th
            *ngFor="let column of group.columns; index as c"
            [class.center]="true"
            [class.left]="false"
            [class.right]="false"
            [class.divider-column]="c === 0 && g > 0"
            [class.clickable]="column.clickable"
          >
            <div class="header-content"
                 [class.clickable-header]="column.clickable"
                 (click)="onHeaderClick(column)">
              <div
                *ngIf="column.fullColumnEdit"
                style="display: flex; flex-direction: column"
              >
                <div class="header-caption">
                  {{ column.caption }}
                  <mat-icon *ngIf="column.icon" class="header-icon">{{ column.icon }}</mat-icon>
                </div>
                <div>
                  <p>
                    <mat-slide-toggle
                      color="primary"
                      hideIcon="true"
                      (change)="columnLockChange(column, $event)"
                      label-position="before"
                    ></mat-slide-toggle>
                  </p>
                </div>
              </div>
              <ng-container *ngIf="!column.fullColumnEdit">
                <div class="header-caption">
                  {{ column.caption }}
                  <mat-icon *ngIf="column.icon" class="header-icon">{{ column.icon }}</mat-icon>
                </div>
                <div *ngIf="column.headerToggle" class="header-toggle">
                  <mat-slide-toggle
                    color="primary"
                    hideIcon="true"
                    [checked]="column.headerToggle.checked()"
                    (change)="column.headerToggle.onChange($event.checked)"
                    [matTooltip]="column.headerToggle.tooltip || ''"
                  ></mat-slide-toggle>
                </div>
              </ng-container>
            </div>
          </th>
        </ng-container>
        <th class="divider-column" *ngIf="buttonsColumnVisible">
          <div class="header-content">
            <ng-container>{{ getCustomButtonsTitle() }}</ng-container>
          </div>
        </th>
      </tr>
    </thead>
    <tbody #tbody>
      <ng-container *ngFor="let item of pageData; index as i">
        <tr
          [ngClass]="[
            rowClasses[i] || '',
            getClass(item, i)['highlight'] ? 'highlight' : '',
            canExpand(item, i) ? 'expandable-row' : '',
            isRowExpanded(i) ? 'expanded-row' : ''
          ]"
          [class.row-clickable]="expandRowOnClick && canExpand(item, i)"
          (click)="onRowClick(item, i, $event)"
        >
        <ng-container *ngFor="let group of dataDefinition; index as g">
          <ng-container *ngIf="shouldDisplayGroup(g, i)">
            <td
              *ngFor="let column of group.columns; index as c"
              [class.center]="true"
              [class.left]="false"
              [class.right]="false"
              [class.divider-column]="c === 0 && g > 0"
              [class.group-0-cell]="g === 0"
              [attr.rowspan]="getRowSpan(g, i)"
              [class.locked]="!column.fullColumnEdit && column.locked"
              [class.unlocked]="column.fullColumnEdit && !column.locked"
            >
              <ng-container
                *ngIf="
                  isInfinityEditable(column, item) || !editableRows.includes(i)
                "
              >
                <ng-container *ngIf="column.valueType == 'boolean'">
                  <ng-container
                    *ngIf="
                      column.fullColumnEdit || isInfinityEditable(column, item)
                    "
                  >
                    <mat-checkbox
                      color="primary"
                      [checked]="
                        item[column.fieldName] ?? column.defaultChecked
                      "
                      (click)="$event.stopPropagation()"
                      (change)="onCheckBoxFieldChanged(column, i, $event)"
                      [disabled]="column.locked"
                    ></mat-checkbox>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !column.fullColumnEdit &&
                      !isInfinityEditable(column, item)
                    "
                  >
                    <mat-checkbox
                      color="primary"
                      [checked]="
                        item[column.fieldName] ?? column.defaultChecked
                      "
                      (click)="$event.stopPropagation()"
                      disabled
                    ></mat-checkbox>
                  </ng-container>
                </ng-container>
                <ng-container
                  *ngIf="column.valueType == 'date' && column.format"
                >
                  {{
                    formatDateValue(item[column.fieldName], column.format, true)
                  }}
                </ng-container>
                <ng-container *ngIf="column.valueType == 'status-icon'">
                  <mat-icon
                    *ngIf="item[column.fieldName] === 'success'"
                    style="color: #4caf50; vertical-align: middle;"
                    matTooltip="Sent to SAP successfully"
                  >check_circle</mat-icon>
                  <mat-icon
                    *ngIf="item[column.fieldName] === 'error'"
                    style="color: #f44336; vertical-align: middle;"
                    matTooltip="Sent to SAP with error"
                  >cancel</mat-icon>
                  <span *ngIf="item[column.fieldName] == null">—</span>
                </ng-container>
                <ng-container
                  *ngIf="
                    column.valueType != 'boolean' &&
                    column.valueType != 'status-icon' &&
                    !(column.valueType == 'date' && column.format)
                  "
                >
                  <ng-container
                    *ngIf="
                      column.fullColumnEdit || isInfinityEditable(column, item)
                    "
                  >
                    <input
                      class="input-edit-mode"
                      [attr.data-header]="column.caption"
                      [value]="item[column.fieldName]"
                      (click)="$event.stopPropagation()"
                      (keyup)="onFieldChanged(column, $event, i)"
                      [ngClass]="{ error: errorMessage(column, i) }"
                    />
                    <ng-container *ngIf="errorMessage(column, i)">
                      <mat-error class="error-message">{{
                        errorMessage(column, i)
                      }}</mat-error>
                    </ng-container>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !column.fullColumnEdit &&
                      !isInfinityEditable(column, item)
                    "
                  >
                    <div class="cell-with-subfields" *ngIf="column.subFields?.length; else plainCell">
                      <span class="cell-main-value">{{ checkLength(item[column.fieldName]) }}</span>
                      <div class="cell-subfields">
                        <span class="cell-subfield" *ngFor="let sub of column.subFields">
                          <span class="cell-subfield-label" *ngIf="sub.label">{{ sub.label }}: </span>
                          <span class="cell-subfield-value">{{ formatSubFieldValue(item, sub.fieldName, sub.valueType, sub.format) }}</span>
                        </span>
                      </div>
                    </div>
                    <ng-template #plainCell>
                      <span>
                        {{ (item[column.fieldName] != null && item[column.fieldName] !== '') ? checkLength(item[column.fieldName]) : '—' }}
                        <span
                          class="pointer"
                          *ngIf="item[column.fieldName]?.length >= maxLength"
                          matTooltip="{{ item[column.fieldName] }}"
                          >(...)</span
                        >
                      </span>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="
                  editableRows.includes(i) && !isInfinityEditable(column, item)
                "
              >
                <ng-container *ngIf="isColumnEditable(column, item)">
                  <ng-container *ngIf="column.valueType == 'boolean'">
                    <mat-checkbox
                      [checked]="
                        dataForEdit[i][column.fieldName] ??
                        column.defaultChecked
                      "
                      (click)="$event.stopPropagation()"
                      (change)="onCheckBoxFieldChanged(column, i, $event)"
                    ></mat-checkbox>
                  </ng-container>
                  <ng-container *ngIf="column.valueType != 'boolean'">
                    <input
                      [disabled]="column.fieldName === 'name'"
                      class="input-edit-mode"
                      [attr.data-header]="column.caption"
                      [value]="dataForEdit[i][column.fieldName]"
                      (click)="$event.stopPropagation()"
                      (keyup)="onFieldChanged(column, $event, i)"
                      [ngClass]="{ error: errorMessage(column, i) }"
                    />
                    <ng-container *ngIf="errorMessage(column, i)">
                      <mat-error class="error-message">{{
                        errorMessage(column, i)
                      }}</mat-error>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!isColumnEditable(column, item)">
                  <ng-container *ngIf="column.valueType == 'boolean'">
                    <mat-checkbox
                      color="primary"
                      [checked]="
                        item[column.fieldName] ?? column.defaultChecked
                      "
                      (click)="$event.stopPropagation()"
                      disabled
                    ></mat-checkbox>
                  </ng-container>
                  <ng-container
                    *ngIf="column.valueType == 'date' && column.format"
                  >
                    {{
                      formatDateValue(
                        item[column.fieldName],
                        column.format,
                        true
                      )
                    }}
                  </ng-container>
                  <ng-container *ngIf="column.valueType == 'status-icon'">
                    <mat-icon
                      *ngIf="item[column.fieldName] === 'success'"
                      style="color: #4caf50; vertical-align: middle;"
                      matTooltip="Sent to SAP successfully"
                    >check_circle</mat-icon>
                    <mat-icon
                      *ngIf="item[column.fieldName] === 'error'"
                      style="color: #f44336; vertical-align: middle;"
                      matTooltip="Sent to SAP with error"
                    >cancel</mat-icon>
                    <span *ngIf="item[column.fieldName] == null">—</span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      column.valueType != 'boolean' &&
                      column.valueType != 'status-icon' &&
                      !(column.valueType == 'date' && column.format)
                    "
                  >
                    {{ item[column.fieldName] }}
                  </ng-container>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="getButtonRowIndex(i)">
          <td
            class="divider-column"
            *ngIf="buttonsColumnVisible"
            [attr.rowspan]="getButtonRowSpan(i)"
          >
            <div class="button-column" (click)="$event.stopPropagation()">
              <ng-container *ngIf="!editableRows.includes(i)">
                <button
                  *ngIf="allowEditing && !isEditMode"
                  mat-icon-button
                  matSuffix
                  matTooltip="Edit"
                  (click)="onEditClick(i)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <ng-container *ngFor="let button of customButtons">
                  <button
                    *ngIf="
                      (button.isVisible == undefined ||
                        button.isVisible(item)) &&
                      !isEditMode
                    "
                    [matTooltip]="button.hint"
                    (click)="button.onClick(item)"
                    mat-icon-button
                    matSuffix
                    [matBadge]="item.attachmentsCount"
                    [matBadgeHidden]="button.hint !== 'Attachments' || item.attachmentsCount === 0"
                  >
                    <mat-icon>{{ button.icon }}</mat-icon>
                  </button>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="editableRows.includes(i)">
                <button
                  mat-icon-button
                  matSuffix
                  matTooltip="Accept"
                  [disabled]="!isRowValid()"
                  (click)="onSaveClick()"
                >
                  <mat-icon>check</mat-icon>
                </button>
                <button
                  mat-icon-button
                  matSuffix
                  matTooltip="Cancel"
                  (click)="onCancelClick()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </ng-container>
            </div>
          </td>
        </ng-container>
        </tr>
        <tr *ngIf="isRowExpanded(i)" class="detail-row">
          <td
            [attr.colspan]="getTotalColumns()"
            class="detail-row-cell"
            (click)="$event.stopPropagation()"
          >
            <ng-container *ngIf="rowDetailsTemplate">
              <ng-container
                [ngTemplateOutlet]="rowDetailsTemplate"
                [ngTemplateOutletContext]="getRowDetailsContext(item, i)"
              >
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
  @if(!sapExportMode){
  <mat-paginator
    (page)="handlePaginatorEvent($event)"
    [pageIndex]="pageIndex"
    [length]="data.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 20, 50]"
    aria-label="Select page"
    [class.disabled]="isEditMode"
  ></mat-paginator>
  }
  <div *ngIf="isLoading === true" class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
